import React from 'react';
import './css/navBar.css';
import LanguageSelector from './LanguageSelector';
import Cookies from 'js-cookie';



const LogInNavBar = ({cambiarIdioma}) => {

    const manejarCambioIdioma = (event) => {
      cambiarIdioma(event.target.value); // Llama a la función pasada como prop
    };
  
  
      return (
        <nav className="custom-navbar">
  {/* <Link to="/" className="navbar_menu_item">
    {i18n.t('inicio')}
    {/* <img className="navbar_logo" src={cernexLogo} alt="Cewy Logo" /> }
 /</nav> </Link> */}
   <LanguageSelector cambiarIdioma={cambiarIdioma} idioma = {Cookies.get('idiomaPreferido')}/>
</nav>
      );
   
  };
  
  export default LogInNavBar;
  